var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8128 9.99954H10.0003M10.0003 9.99954H7.18781M10.0003 9.99954V12.812M10.0003 9.99954L10.0003 7.18706M17.5 5.31248L17.5 14.6875C17.5 16.2408 16.2408 17.5 14.6875 17.5H5.3125C3.7592 17.5 2.5 16.2408 2.5 14.6875V5.31248C2.5 3.75919 3.7592 2.5 5.3125 2.5H14.6875C16.2408 2.5 17.5 3.75919 17.5 5.31248Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.1b8fe79f21be8be793e519f28d4fa7f4.svg";
export { ForwardRef as ReactComponent };